var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.969727,
    width: 23.9515,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9435 11.6V8C13.9435 7.71667 13.8478 7.47917 13.6566 7.2875C13.4653 7.09583 13.2283 7 12.9455 7C12.6627 7 12.4257 7.09583 12.2344 7.2875C12.0432 7.47917 11.9475 7.71667 11.9475 8V11.975C11.9475 12.1083 11.9725 12.2375 12.0224 12.3625C12.0723 12.4875 12.1471 12.6 12.2469 12.7L15.5402 16C15.7232 16.1833 15.9561 16.275 16.2388 16.275C16.5216 16.275 16.7545 16.1833 16.9374 16C17.1204 15.8167 17.2119 15.5833 17.2119 15.3C17.2119 15.0167 17.1204 14.7833 16.9374 14.6L13.9435 11.6ZM12.9455 22C11.565 22 10.2676 21.7375 9.05338 21.2125C7.83917 20.6875 6.78297 19.975 5.88479 19.075C4.98661 18.175 4.27555 17.1167 3.75161 15.9C3.22767 14.6833 2.9657 13.3833 2.9657 12C2.9657 10.6167 3.22767 9.31667 3.75161 8.1C4.27555 6.88333 4.98661 5.825 5.88479 4.925C6.78297 4.025 7.83917 3.3125 9.05338 2.7875C10.2676 2.2625 11.565 2 12.9455 2C14.326 2 15.6234 2.2625 16.8376 2.7875C18.0518 3.3125 19.108 4.025 20.0062 4.925C20.9044 5.825 21.6154 6.88333 22.1394 8.1C22.6633 9.31667 22.9253 10.6167 22.9253 12C22.9253 13.3833 22.6633 14.6833 22.1394 15.9C21.6154 17.1167 20.9044 18.175 20.0062 19.075C19.108 19.975 18.0518 20.6875 16.8376 21.2125C15.6234 21.7375 14.326 22 12.9455 22ZM12.9455 20C15.1577 20 17.0414 19.2208 18.5966 17.6625C20.1517 16.1042 20.9293 14.2167 20.9293 12C20.9293 9.78333 20.1517 7.89583 18.5966 6.3375C17.0414 4.77917 15.1577 4 12.9455 4C10.7333 4 8.84962 4.77917 7.29444 6.3375C5.73925 7.89583 4.96166 9.78333 4.96166 12C4.96166 14.2167 5.73925 16.1042 7.29444 17.6625C8.84962 19.2208 10.7333 20 12.9455 20Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.1352e266f6aa8faf8ef89da707e0663f.svg";
export { ForwardRef as ReactComponent };